import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/footer/index';

const features = [
  { title: 'ERP Terintegrasi', desc: 'Sistem Enterprise Resource Planning yang menghubungkan seluruh departemen dalam satu platform.', icon: '🏗️' },
  { title: 'CRM Sales Pipeline', desc: 'Kelola prospek, deal, dan pelanggan dengan pipeline penjualan visual yang intuitif.', icon: '📊' },
  { title: 'Inventory Management', desc: 'Pantau stok, pembelian, dan distribusi secara real-time dengan notifikasi otomatis.', icon: '📦' },
  { title: 'Financial Accounting', desc: 'Modul akuntansi lengkap dari jurnal, buku besar, hingga laporan keuangan.', icon: '💰' },
  { title: 'Business Intelligence', desc: 'Dashboard analitik dengan visualisasi data untuk pengambilan keputusan strategis.', icon: '📈' },
  { title: 'Kustomisasi Penuh', desc: 'Sistem dapat disesuaikan 100% dengan proses bisnis unik perusahaan Anda.', icon: '⚙️' },
];

const ErpCrmPage = () => {
  React.useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <section className="relative bg-gradient-to-br from-purple-900 via-indigo-800 to-violet-900 text-white py-24 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">ERP & CRM System</h1>
          <p className="text-lg md:text-xl text-purple-200 max-w-3xl mx-auto">
            Solusi ERP dan CRM enterprise untuk mengoptimalkan operasional dan meningkatkan hubungan pelanggan.
          </p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800 dark:text-white">Fitur Unggulan</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((f) => (
              <div key={f.title} className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                <div className="text-4xl mb-4">{f.icon}</div>
                <h3 className="text-xl font-bold mb-3 text-gray-800 dark:text-white">{f.title}</h3>
                <p className="text-gray-600 dark:text-gray-300">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-indigo-900 text-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Optimalkan Bisnis Anda</h2>
          <p className="text-indigo-200 mb-8">Dapatkan demo gratis dan lihat bagaimana ERP & CRM kami dapat mentransformasi bisnis Anda.</p>
          <Link to="/kontak" className="inline-block bg-white text-indigo-900 font-bold px-8 py-4 rounded-xl hover:bg-indigo-50 transition-colors">
            Request Demo
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ErpCrmPage;
